import { render } from "./Systems.vue?vue&type=template&id=5a72bbea&scoped=true"
import script from "./Systems.vue?vue&type=script&lang=js"
export * from "./Systems.vue?vue&type=script&lang=js"

import "./Systems.vue?vue&type=style&index=0&id=5a72bbea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a72bbea"]])

export default __exports__